import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getImageUrl } from '../../../../../helpers/imageUrl';
import { getHomeCategories } from '../../../../../services/categories/actions';
import './CategoryGrid.css';

class CategoryGrid extends Component {
  constructor(props) {
    super(props);
    console.log('🔧 CategoryGrid constructor called');
    this.state = {
      currentPage: 0,
      itemsPerPage: 8
    };
    this.gridRef = React.createRef();
  }

  // Load home page categories using Redux
  async componentDidMount() {
    console.log('🔧 CategoryGrid componentDidMount called');
    console.log('🔧 Current homeCategories length:', this.props.homeCategories.length);
    console.log('🔧 Current homeCategoriesLoading:', this.props.homeCategoriesLoading);
    
    // Always fetch categories to ensure fresh data
    console.log('🔧 Calling getHomeCategories action...');
    this.props.getHomeCategories();
  }

  // Scroll to the selected page when indicator is clicked
  scrollToPage = (pageIndex) => {
    const grid = this.gridRef.current;
    if (grid) {
      // Get all page elements
      const pages = grid.querySelectorAll('.category-page');
      if (pages.length > pageIndex) {
        // Scroll to the selected page element
        pages[pageIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        this.setState({ currentPage: pageIndex });
      }
    }
  };

  // Handle horizontal scroll to update current page
  handleScroll = () => {
    const grid = this.gridRef.current;
    if (grid) {
      // Calculate which page is most visible
      const scrollLeft = grid.scrollLeft;
      const containerWidth = grid.clientWidth;
      const pages = Array.from(grid.querySelectorAll('.category-page'));
      
      // Find which page is most visible in the viewport
      let currentPage = 0;
      let maxVisibleWidth = 0;
      
      pages.forEach((page, index) => {
        const rect = page.getBoundingClientRect();
        const gridRect = grid.getBoundingClientRect();
        
        // Calculate how much of the page is visible
        const leftEdge = Math.max(rect.left, gridRect.left);
        const rightEdge = Math.min(rect.right, gridRect.right);
        const visibleWidth = Math.max(0, rightEdge - leftEdge);
        
        if (visibleWidth > maxVisibleWidth) {
          maxVisibleWidth = visibleWidth;
          currentPage = index;
        }
      });
      
      if (currentPage !== this.state.currentPage) {
        this.setState({ currentPage });
      }
    }
  };

  render() {
    console.log('🎨 CategoryGrid render method called');
    console.log('🎨 homeCategories:', this.props.homeCategories);
    console.log('🎨 homeCategoriesLoading:', this.props.homeCategoriesLoading);
    console.log('🎨 homeCategoriesError:', this.props.homeCategoriesError);
    
    const { currentPage, itemsPerPage } = this.state;
    const { homeCategories, homeCategoriesLoading, homeCategoriesError } = this.props;
    
    if (homeCategoriesLoading) {
      return (
        <div className="category-carousel-wrapper">
          <div className="loading-placeholder">Loading categories...</div>
        </div>
      );
    }
    
    if (homeCategoriesError) {
      return (
        <div className="category-carousel-wrapper">
          <div className="error-placeholder">Error: {homeCategoriesError}</div>
        </div>
      );
    }

    // Take only first 15 categories (exclude the 16th Technology category)
    const categoriesForCarousel = homeCategories.slice(0, 15);
    const totalPages = Math.ceil(categoriesForCarousel.length / itemsPerPage);

    return (
      <div className="category-carousel-wrapper">
        {/* Horizontally scrollable grid with pages */}
        <div
          className="category-grid-scroll"
          ref={this.gridRef}
          onScroll={this.handleScroll}
        >
          {Array.from({ length: totalPages }).map((_, pageIndex) => {
            const start = pageIndex * itemsPerPage;
            const end = start + itemsPerPage;
            const pageCategories = categoriesForCarousel.slice(start, end);
            
            // Check if this is the last page (page 2, index 1)
            const isLastPage = pageIndex === totalPages - 1;
            
            // For the last page, show only 7 categories + View More button
            const maxItemsForPage = isLastPage ? 7 : itemsPerPage;
            const displayCategories = isLastPage ? pageCategories.slice(0, 7) : pageCategories;
            
            // Fill any empty slots to maintain grid structure
            const filledPageCategories = [...displayCategories];
            while (filledPageCategories.length < maxItemsForPage) {
              filledPageCategories.push({ id: `empty-${filledPageCategories.length}`, isEmpty: true });
            }
            
            return (
              <div className="category-page" key={pageIndex}>
                {filledPageCategories.map(category => 
                  category.isEmpty ? (
                    <div key={category.id} className="category-item" style={{ visibility: 'hidden' }}></div>
                  ) : (
                    <Link
                      key={category.id}
                      to={`/phase2/category/${category.slug}`}
                      className="category-item"
                    >
                      <img
                        src={category.placeholder}
                        alt={category.name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = getImageUrl('/assets/img/categories/placeholder.jpg');
                        }}
                      />
                      <span>{category.name}</span>
                    </Link>
                  )
                )}
                
                {/* Add circular View More button in 8th position on last page */}
                {isLastPage && (
                  <Link
                    to="/phase2/categories"
                    className="category-item view-more-circular"
                  >
                    <div className="view-more-circle">
                      <span>View<br/>More</span>
                    </div>
                  </Link>
                )}
              </div>
            );
          })}
        </div>

        {/* Only indicator dots below */}
        {totalPages > 1 && (
          <div className="carousel-indicators">
            {Array.from({ length: totalPages }).map((_, index) => (
              <div
                key={index}
                className={`indicator ${currentPage === index ? 'active' : ''}`}
                onClick={() => this.scrollToPage(index)}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  homeCategories: state.categories.homeCategories,
  homeCategoriesLoading: state.categories.homeCategoriesLoading,
  homeCategoriesError: state.categories.homeCategoriesError
});

const mapDispatchToProps = {
  getHomeCategories
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryGrid); 